function initBrandDayLotteries() {
  document.querySelectorAll('[data-brand-day-lottery]').forEach(function (root) {
    if (!root || root.dataset.lotteryBound === 'true') return;
    root.dataset.lotteryBound = 'true';

    const configScript = root.querySelector('script[data-roulette-config]');
    if (!configScript) return;
    let cfg;
    try {
      cfg = JSON.parse(configScript.textContent);
    } catch (e) {
      return;
    }

    const apiUrl = cfg.apiUrl;
    const tokenUrl = cfg.tokenUrl || 'https://global.shokz.com/lottery/start';
    const signSecret = cfg.signSecret || '';
    const actId = cfg.actId;
    const almostPrizeKey = buildPrizeKey(cfg.actId, cfg.almostPriceId);
    const almostSectorDegDesktop = Number(cfg.almostSectorDegDesktop);
    const almostSectorDegMobile = Number(cfg.almostSectorDegMobile);
    const missSectorDegDesktop = Number(cfg.missSectorDegDesktop);
    const missSectorDegMobile = Number(cfg.missSectorDegMobile);
    const spinTotalMs = Number(cfg.spinTotalMs) || 4600;
    const decelMs = Number(cfg.decelMs) || 1000;
    const ga4ButtonName = cfg.ga4ButtonName || 'Spin_To_Win';
    const ga4ModuleName = cfg.ga4ModuleName || '';
    const klaviyoFormClass = cfg.klaviyoFormClass;
    const usageScenarios = cfg.usageScenarios || 'cs';
    const getTokenUrl = cfg.getTokenUrl || 'https://global.shokz.com/api/v1/get-token';
    const prizeQueryUrl = cfg.prizeQueryUrl || 'https://global.shokz.com/api/v1/lottery/all-prize-query';
    const xSite = cfg.xSite || 'ca';
    const apiKey = cfg.apiKey || '';

    // Prizes are matched by the composite key actId + priceId (string concatenation)
    // rather than a single actPriceId. actId is the section-level activity ID; each
    // prize only configures price_id. The backend returns both fields; we concat them
    // and compare against actId + the block's configured price_id.
    function buildPrizeKey(actId, priceId) {
      return String(actId == null ? '' : actId) + String(priceId == null ? '' : priceId);
    }

    // ---- v3 lottery auth: token + sign ----
    // sign = md5(String(actId) + '|' + signSecret); the token is fetched once per
    // actId and cached until near expiry (openapi_v3 requires both on the draw call).
    const tokenCache = {};

    /* Compact MD5 (sign = md5(actId + "|" + signSecret)) */
    function md5(string) {
      function md5cycle(x, k) {
        let a = x[0];
        let b = x[1];
        let c = x[2];
        let d = x[3];
        a = ff(a, b, c, d, k[0], 7, -680876936);
        d = ff(d, a, b, c, k[1], 12, -389564586);
        c = ff(c, d, a, b, k[2], 17, 606105819);
        b = ff(b, c, d, a, k[3], 22, -1044525330);
        a = ff(a, b, c, d, k[4], 7, -176418897);
        d = ff(d, a, b, c, k[5], 12, 1200080426);
        c = ff(c, d, a, b, k[6], 17, -1473231341);
        b = ff(b, c, d, a, k[7], 22, -45705983);
        a = ff(a, b, c, d, k[8], 7, 1770035416);
        d = ff(d, a, b, c, k[9], 12, -1958414417);
        c = ff(c, d, a, b, k[10], 17, -42063);
        b = ff(b, c, d, a, k[11], 22, -1990404162);
        a = ff(a, b, c, d, k[12], 7, 1804603682);
        d = ff(d, a, b, c, k[13], 12, -40341101);
        c = ff(c, d, a, b, k[14], 17, -1502002290);
        b = ff(b, c, d, a, k[15], 22, 1236535329);
        a = gg(a, b, c, d, k[1], 5, -165796510);
        d = gg(d, a, b, c, k[6], 9, -1069501632);
        c = gg(c, d, a, b, k[11], 14, 643717713);
        b = gg(b, c, d, a, k[0], 20, -373897302);
        a = gg(a, b, c, d, k[5], 5, -701558691);
        d = gg(d, a, b, c, k[10], 9, 38016083);
        c = gg(c, d, a, b, k[15], 14, -660478335);
        b = gg(b, c, d, a, k[4], 20, -405537848);
        a = gg(a, b, c, d, k[9], 5, 568446438);
        d = gg(d, a, b, c, k[14], 9, -1019803690);
        c = gg(c, d, a, b, k[3], 14, -187363961);
        b = gg(b, c, d, a, k[8], 20, 1163531501);
        a = gg(a, b, c, d, k[13], 5, -1444681467);
        d = gg(d, a, b, c, k[2], 9, -51403784);
        c = gg(c, d, a, b, k[7], 14, 1735328473);
        b = gg(b, c, d, a, k[12], 20, -1926607734);
        a = hh(a, b, c, d, k[5], 4, -378558);
        d = hh(d, a, b, c, k[8], 11, -2022574463);
        c = hh(c, d, a, b, k[11], 16, 1839030562);
        b = hh(b, c, d, a, k[14], 23, -35309556);
        a = hh(a, b, c, d, k[1], 4, -1530992060);
        d = hh(d, a, b, c, k[4], 11, 1272893353);
        c = hh(c, d, a, b, k[7], 16, -155497632);
        b = hh(b, c, d, a, k[10], 23, -1094730640);
        a = hh(a, b, c, d, k[13], 4, 681279174);
        d = hh(d, a, b, c, k[0], 11, -358537222);
        c = hh(c, d, a, b, k[3], 16, -722521979);
        b = hh(b, c, d, a, k[6], 23, 76029189);
        a = hh(a, b, c, d, k[9], 4, -640364487);
        d = hh(d, a, b, c, k[12], 11, -421815835);
        c = hh(c, d, a, b, k[15], 16, 530742520);
        b = hh(b, c, d, a, k[2], 23, -995338651);
        a = ii(a, b, c, d, k[0], 6, -198630844);
        d = ii(d, a, b, c, k[7], 10, 1126891415);
        c = ii(c, d, a, b, k[14], 15, -1416354905);
        b = ii(b, c, d, a, k[5], 21, -57434055);
        a = ii(a, b, c, d, k[12], 6, 1700485571);
        d = ii(d, a, b, c, k[3], 10, -1894986606);
        c = ii(c, d, a, b, k[10], 15, -1051523);
        b = ii(b, c, d, a, k[1], 21, -2054922799);
        a = ii(a, b, c, d, k[8], 6, 1873313359);
        d = ii(d, a, b, c, k[15], 10, -30611744);
        c = ii(c, d, a, b, k[6], 15, -1560198380);
        b = ii(b, c, d, a, k[13], 21, 1309151649);
        a = ii(a, b, c, d, k[4], 6, -145523070);
        d = ii(d, a, b, c, k[11], 10, -1120210379);
        c = ii(c, d, a, b, k[2], 15, 718787259);
        b = ii(b, c, d, a, k[9], 21, -343485551);
        x[0] = add32(a, x[0]);
        x[1] = add32(b, x[1]);
        x[2] = add32(c, x[2]);
        x[3] = add32(d, x[3]);
      }
      function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32((a << s) | (a >>> (32 - s)), b);
      }
      function ff(a, b, c, d, x, s, t) {
        return cmn((b & c) | (~b & d), a, b, x, s, t);
      }
      function gg(a, b, c, d, x, s, t) {
        return cmn((b & d) | (c & ~d), a, b, x, s, t);
      }
      function hh(a, b, c, d, x, s, t) {
        return cmn(b ^ c ^ d, a, b, x, s, t);
      }
      function ii(a, b, c, d, x, s, t) {
        return cmn(c ^ (b | ~d), a, b, x, s, t);
      }
      function md5blk(s) {
        const md5blks = [];
        let i;
        for (i = 0; i < 64; i += 4) {
          md5blks[i >> 2] =
            s.charCodeAt(i) +
            (s.charCodeAt(i + 1) << 8) +
            (s.charCodeAt(i + 2) << 16) +
            (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
      }
      function md51(s) {
        const n = s.length;
        const state = [1732584193, -271733879, -1732584194, 271733878];
        let i;
        for (i = 64; i <= n; i += 64) {
          md5cycle(state, md5blk(s.substring(i - 64, i)));
        }
        s = s.substring(i - 64);
        const tail = [];
        for (i = 0; i < 16; i++) tail[i] = 0;
        for (i = 0; i < s.length; i++) tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) * 8);
        tail[i >> 2] |= 0x80 << ((i % 4) * 8);
        if (i > 55) {
          md5cycle(state, tail);
          for (i = 0; i < 16; i++) tail[i] = 0;
        }
        tail[14] = n * 8;
        md5cycle(state, tail);
        return state;
      }
      function rhex(n) {
        let s = '';
        let j;
        for (j = 0; j < 4; j++) s += ('0' + ((n >> (j * 8)) & 255).toString(16)).slice(-2);
        return s;
      }
      function hex(x) {
        let i;
        for (i = 0; i < x.length; i++) x[i] = rhex(x[i]);
        return x.join('');
      }
      function add32(a, b) {
        return (a + b) & 0xffffffff;
      }
      return hex(md51(unescape(encodeURIComponent(string))));
    }

    function buildSign(actIdValue, secret) {
      return md5(String(actIdValue) + '|' + String(secret || ''));
    }

    // Derive the three lookup tables (formerly hardcoded) from prize blocks.
    const prizes = Array.isArray(cfg.prizes) ? cfg.prizes : [];
    const validPrizeKeys = new Set();
    const prizeKeyToSectorDegDesktop = {};
    const prizeKeyToSectorDegMobile = {};
    const prizeKeyToPrizeMeta = {};
    prizes.forEach(function (p) {
      const key = buildPrizeKey(actId, p.priceId);
      if (!key) return;
      validPrizeKeys.add(key);
      prizeKeyToSectorDegDesktop[key] = Number(p.sectorDegDesktop);
      prizeKeyToSectorDegMobile[key] = Number(p.sectorDegMobile);
      prizeKeyToPrizeMeta[key] = {
        type: p.type || 'miss',
        name: p.type === 'product' ? p.value || '' : undefined,
        amount: p.type === 'coupon' ? p.value || '' : undefined,
        headingOverride: p.headingOverride || '',
        subOverride: p.subOverride || '',
        variantIds: Array.isArray(p.variantIds) ? p.variantIds : [],
        prizeCode: p.prizeCode || '',
      };
    });
    // Miss is its own outcome (not a prize block), so its copy is always the
    // "miss" template regardless of fallback_act_price_id.
    const fallbackMeta = { type: 'miss' };

    const resultTemplates = (cfg.copy && cfg.copy.resultTemplates) || {};
    const actStatusResultCopy = (cfg.copy && cfg.copy.blocked) || {};

    function isMobile() {
      return !window.matchMedia('(min-width: 901px)').matches;
    }

    function getSectorDeg(prizeKey) {
      const map = isMobile() ? prizeKeyToSectorDegMobile : prizeKeyToSectorDegDesktop;
      return map[prizeKey] ?? 180;
    }

    // "almost" is a real prize that isn't shown on the wheel, and "miss" is a true
    // non-win. Neither is a carousel block, so both angles are section-level settings.
    function getAlmostSectorDeg() {
      const deg = isMobile() ? almostSectorDegMobile : almostSectorDegDesktop;
      return Number.isFinite(deg) ? deg : 0;
    }
    function getMissSectorDeg() {
      const deg = isMobile() ? missSectorDegMobile : missSectorDegDesktop;
      return Number.isFinite(deg) ? deg : 0;
    }

    const klaviyoContainer = klaviyoFormClass ? root.querySelector('.' + klaviyoFormClass) : null;

    root.querySelectorAll('.prize-cards__info').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        const willOpen = !btn.classList.contains('is-open');
        root.querySelectorAll('.prize-cards__info.is-open').forEach(function (openBtn) {
          openBtn.classList.remove('is-open');
          openBtn.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          btn.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function () {
      root.querySelectorAll('.prize-cards__info.is-open').forEach(function (openBtn) {
        openBtn.classList.remove('is-open');
        openBtn.setAttribute('aria-expanded', 'false');
      });
    });

    if (!klaviyoContainer) return;

    const agreementEl = root.querySelector('.agreement-checkbox');
    const h2El = root.querySelector('[data-lottery-heading]');
    const descEl = root.querySelector('[data-lottery-desc]');
    const resultSubEl = root.querySelector('[data-lottery-result-sub]');
    const resultNoteEl = root.querySelector('[data-lottery-result-note]');

    function isElementVisible(el) {
      if (!el) return false;
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    function getActiveWheelImg() {
      const imgs = root.querySelectorAll('.wheel-img');
      for (const img of imgs) {
        const wrap = img.closest('.wheel-wrap');
        if (!wrap) continue;
        if (isElementVisible(wrap)) return img;
      }
      return imgs[0] || null;
    }

    let buttonHasAppeared = false;
    let retryCount = 0;
    const maxRetries = 8;
    const retryInterval = 900;
    let buttonClicked = false;
    let buttonClickedAtMs = 0;
    let submittedEmail = '';
    let completed = false;

    function findInner() {
      const button = klaviyoContainer.querySelector('button');
      const input = klaviyoContainer.querySelector('input');
      const form = klaviyoContainer.querySelector('form');
      return { button, input, form };
    }

    function hideAllWheelHints() {
      root.querySelectorAll('[data-wheel-hint]').forEach((hint) => {
        hint.classList.remove('is-visible');
        hint.setAttribute('aria-hidden', 'true');
      });
    }

    function showWheelHintForWrap(wheelWrap) {
      const hint = wheelWrap.querySelector('[data-wheel-hint]');
      if (!hint) return;
      hideAllWheelHints();
      hint.classList.add('is-visible');
      hint.setAttribute('aria-hidden', 'false');
    }

    // Result popup — overlays the wheel with the draw result (heading + sub).
    function hideAllWheelResults() {
      root.querySelectorAll('[data-wheel-result]').forEach((el) => {
        el.classList.remove('is-visible');
        el.setAttribute('aria-hidden', 'true');
      });
    }

    function showWheelResult(copy) {
      const wheelImgEl = getActiveWheelImg();
      const wheelWrap = wheelImgEl ? wheelImgEl.closest('.wheel-wrap') : null;
      if (!wheelWrap) return;
      const result = wheelWrap.querySelector('[data-wheel-result]');
      if (!result) return;
      hideAllWheelResults();
      const headingEl = result.querySelector('[data-wheel-result-heading]');
      const subEl = result.querySelector('[data-wheel-result-sub]');
      const heading = (copy && copy.heading) || '';
      const sub = (copy && (copy.sub || copy.main)) || '';
      if (headingEl) headingEl.innerHTML = heading;
      if (subEl) subEl.textContent = sub;
      result.classList.add('is-visible');
      result.setAttribute('aria-hidden', 'false');
    }

    const promptEl = root.querySelector('[data-lottery-prompt]');
    const initialPromptText = promptEl ? promptEl.textContent : '';

    // ---- 技能测试（CA 合规，对齐 common-roulette / utmb26-strava-lottery）----
    // 流程（3.3.4）：留邮 → 抽奖接口返回 → 中奖先出结果 → 2s 后切换技能测试 →
    // 提交（答案非空即可，不校验）→ 切回开奖结果。未中奖不出现技能测试。
    const skillTestEl = root.querySelector('[data-lottery-skill-test]');
    const skillTestFormEl = root.querySelector('[data-lottery-skill-test-form]');
    const skillTestQuestionEl = root.querySelector('[data-lottery-skill-test-question]');
    const skillTestInputEl = root.querySelector('[data-lottery-skill-test-input]');

    const FALLBACK_SKILL_BANK = [
      { ques: 1, numbers: [4, 2, 2, 1], operations: ['/', '+', '-'], answer: 3 },
      { ques: 2, numbers: [6, 2, 1, 1], operations: ['÷', '+', '-'], answer: 3 },
      { ques: 3, numbers: [8, 4, 3, 1], operations: ['÷', '+', '-'], answer: 4 },
      { ques: 4, numbers: [9, 3, 2, 1], operations: ['÷', '×', '-'], answer: 5 },
      { ques: 5, numbers: [5, 5, 2, 1], operations: ['+', '-', '×'], answer: 8 },
      { ques: 6, numbers: [7, 1, 2, 2], operations: ['+', '×', '-'], answer: 14 },
      { ques: 7, numbers: [10, 2, 3, 1], operations: ['÷', '+', '-'], answer: 7 },
      { ques: 8, numbers: [3, 3, 2, 1], operations: ['×', '+', '-'], answer: 10 },
    ];

    function parseSkillBank() {
      const node = root.querySelector('script[data-lottery-skill-test-bank]');
      if (!node) return FALLBACK_SKILL_BANK;
      try {
        const parsed = JSON.parse(node.textContent);
        if (!Array.isArray(parsed) || !parsed.length) return FALLBACK_SKILL_BANK;
        return parsed.filter(
          (item) =>
            Array.isArray(item && item.numbers) &&
            item.numbers.length === 4 &&
            Array.isArray(item && item.operations) &&
            item.operations.length === 3
        );
      } catch (e) {
        return FALLBACK_SKILL_BANK;
      }
    }

    function pickSkillQuestion(bank) {
      const list = bank && bank.length ? bank : FALLBACK_SKILL_BANK;
      if (!window.crypto || !window.crypto.getRandomValues) {
        return list[Math.floor(Math.random() * list.length)];
      }
      const values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return list[values[0] % list.length];
    }

    function formatSkillExpression(question) {
      const numbers = (question && question.numbers) || [];
      const operations = (question && question.operations) || [];
      if (numbers.length !== 4 || operations.length !== 3) return '';
      return `${numbers[0]}${operations[0]}${numbers[1]}${operations[1]}${numbers[2]}${operations[2]}${numbers[3]}=？`;
    }

    let skillTestSubmitResolve = null;
    if (skillTestFormEl) {
      skillTestFormEl.addEventListener('submit', function (e) {
        e.preventDefault();
        if (skillTestSubmitResolve) {
          const resolve = skillTestSubmitResolve;
          skillTestSubmitResolve = null;
          resolve();
        }
      });
    }

    // 显示技能测试题；返回 Promise（用户提交后 resolve）。
    // DOM 或题库异常时返回 false，调用方直接继续原有流程。
    function showSkillTest() {
      if (!skillTestEl || !skillTestQuestionEl) return Promise.resolve(false);

      const expression = formatSkillExpression(pickSkillQuestion(parseSkillBank()));
      if (!expression) return Promise.resolve(false);

      skillTestQuestionEl.textContent = expression;
      if (skillTestInputEl) skillTestInputEl.value = '';
      skillTestEl.hidden = false;
      skillTestEl.removeAttribute('hidden');
      // 技能测试位于 idle 区：退出结果态，让面板可见（结果态会隐藏整个 idle 区）。
      root.classList.remove('is-result', 'is-result--miss', 'is-win');
      if (skillTestInputEl) window.setTimeout(() => skillTestInputEl.focus(), 0);

      return new Promise(function (resolve) {
        skillTestSubmitResolve = resolve;
      });
    }

    function hideSkillTest() {
      if (!skillTestEl) return;
      skillTestEl.hidden = true;
      skillTestEl.setAttribute('hidden', '');
    }

    root.querySelectorAll('.wheel-img').forEach((wheelImg) => {
      wheelImg.addEventListener('click', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'select_content',
          event_parameters: {
            content_type: 'email',
            content_name: ga4ButtonName,
            button_name: 'Lottery',
          },
        });

        if (completed) return;
        const { input } = findInner();
        const email = input && input.value ? input.value.trim() : '';
        if (email) return;
        if (promptEl) promptEl.textContent = 'Please enter your email before spinning.';
        const wheelWrap = wheelImg.closest('.wheel-wrap');
        if (!wheelWrap) return;
        showWheelHintForWrap(wheelWrap);
      });
    });

    root.querySelectorAll('.wheel-hint__close').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const hint = btn.closest('[data-wheel-hint]');
        if (hint) {
          hint.classList.remove('is-visible');
          hint.setAttribute('aria-hidden', 'true');
        }
      });
    });

    root.querySelectorAll('.wheel-result__close').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const result = btn.closest('[data-wheel-result]');
        if (result) {
          result.classList.remove('is-visible');
          result.setAttribute('aria-hidden', 'true');
        }
      });
    });

    function applyButtonEnablement(button) {
      if (!button) return;
      const checked = agreementEl ? agreementEl.checked : true;
      button.style.pointerEvents = checked ? 'auto' : 'none';
      button.style.opacity = checked ? '1' : '0.5';
    }

    function isButtonHidden(button) {
      if (!button) return true;
      const style = window.getComputedStyle(button);
      return style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0';
    }

    // Klaviyo's success state removes (or hides) the email input. This is a more
    // reliable "submit accepted" signal than the button, because some Klaviyo
    // success states keep a button (e.g. a confirm/close CTA) while still taking
    // the email field away — which would leave the button-based check stuck and
    // Klaviyo's default "Thanks for subscribing!" message visible.
    function isEmailInputGone() {
      const emailInput =
        klaviyoContainer.querySelector('input[type="email"]') ||
        klaviyoContainer.querySelector('input[type="text"]');
      if (!emailInput) return true;
      const style = window.getComputedStyle(emailInput);
      return (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        Number(style.opacity) === 0
      );
    }

    function getRotationDeg(el) {
      const transform = window.getComputedStyle(el).transform;
      if (!transform || transform === 'none') return 0;
      const match = transform.match(/matrix\(([^)]+)\)/);
      if (!match) return 0;
      const parts = match[1].split(',').map((s) => Number(s.trim()));
      const a = parts[0];
      const b = parts[1];
      return Math.atan2(b, a) * (180 / Math.PI);
    }

    function normalizeDeg(deg) {
      const x = deg % 360;
      return x < 0 ? x + 360 : x;
    }

    let claimOverride = null;
    let wonVariantIds = [];
    let wonPrizeCode = '';

    function variantIdList(ids) {
      return (Array.isArray(ids) ? ids : []).map(Number).filter(Boolean);
    }

    function fillToken(text, token, value) {
      return String(text || '').split(token).join(value);
    }

    function customerLoggedIn() {
      return !!(window.customer && String(window.customer.id || '').length);
    }

    function prizeAlreadyClaimed() {
      const tags = window.customer && window.customer.tags;
      return Array.isArray(tags) && tags.indexOf('ShokzSquad_BD_redeemed') !== -1;
    }

    function resolveClaimState() {
      if (claimOverride) return claimOverride;
      if (!customerLoggedIn()) return 'guest';
      if (prizeAlreadyClaimed()) return 'claimed';
      return 'ready';
    }

    function showClaim(state) {
      root.querySelectorAll('[data-lottery-claim]').forEach(function (el) {
        el.hidden = el.getAttribute('data-lottery-claim') !== state;
      });
    }

    function hideClaim() {
      root.querySelectorAll('[data-lottery-claim]').forEach(function (el) {
        el.hidden = true;
      });
    }

    function buildResultCopy(meta) {
      const tpl = resultTemplates[meta.type] || resultTemplates.miss || { heading: '', sub: '' };
      let heading = meta.headingOverride || tpl.heading || '';
      let sub = meta.subOverride || tpl.sub || '';
      let note = tpl.note || '';
      if (meta.type === 'product' && meta.name) {
        heading = fillToken(heading, '%name%', meta.name);
        sub = fillToken(sub, '%name%', meta.name);
      } else if (meta.type === 'coupon' && meta.amount) {
        heading = fillToken(heading, '%amount%', meta.amount);
        sub = fillToken(sub, '%amount%', meta.amount);
      }
      return {
        heading: heading,
        sub: sub,
        note: note,
        claim: meta.type === 'product' || meta.type === 'coupon',
      };
    }

    function setResultCopy(copy) {
      if (!h2El || !descEl || !resultSubEl) return;

      root.classList.remove('is-result', 'is-result--miss', 'is-win');
      h2El.hidden = false;
      h2El.innerHTML = copy.heading;
      descEl.textContent = copy.main || copy.sub;

      if (copy.main && copy.sub) {
        resultSubEl.textContent = copy.sub;
        resultSubEl.hidden = false;
      } else {
        resultSubEl.textContent = '';
        resultSubEl.hidden = true;
      }

      // Tertiary note (e.g. product-win "prize is on its way" line).
      if (resultNoteEl) {
        if (copy.note) {
          resultNoteEl.textContent = copy.note;
          resultNoteEl.hidden = false;
        } else {
          resultNoteEl.textContent = '';
          resultNoteEl.hidden = true;
        }
      }

      root.classList.add('is-result');
      if (!copy.main) {
        root.classList.add('is-result--miss');
      }
      if (copy.claim) {
        wonVariantIds = variantIdList(copy.variantIds);
        wonPrizeCode = copy.prizeCode || '';
        root.classList.add('is-win');
        // CA brand day: winners are notified by email, so no claim/sign-in button.
        hideClaim();
      } else {
        wonVariantIds = [];
        wonPrizeCode = '';
        hideClaim();
      }
    }

    const claimButton = root.querySelector('[data-lottery-claim="ready"]');
    let claimBusy = false;
    if (claimButton) {
      claimButton.addEventListener('click', async function () {
        if (claimBusy || claimButton.disabled) return;
        const ids = wonVariantIds.slice();
        const prizeCode = wonPrizeCode;
        console.log('[roulette claim] 1. 点击 Claim now', { variantIds: ids, prizeCode: prizeCode });
        if (!ids.length) {
          console.warn('[roulette claim] 中止：当前奖等没有可加购的商品');
          return;
        }
        claimBusy = true;
        claimButton.classList.add('loading');
        claimButton.setAttribute('aria-busy', 'true');
        const spinner = claimButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        const headers = {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        };
        const items = ids.map(function (id) {
          const line = { id: id, quantity: 1 };
          if (prizeCode) line.properties = { _ShokzSquad_lottery_prize: prizeCode };
          return line;
        });
        let step = '清空购物车';
        try {
          console.log('[roulette claim] 2. 清空购物车');
          const cleared = await fetch('/cart/clear.js', { method: 'POST', headers: headers });
          const clearedBody = await cleared.json().catch(function () { return null; });
          if (!cleared.ok) throw new Error('clear ' + cleared.status);
          console.log('[roulette claim] 3. 购物车已清空', clearedBody);

          step = '加购中奖商品';
          console.log('[roulette claim] 4. 加购中奖商品', items);
          const added = await fetch('/cart/add.js', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ items: items }),
          });
          const addedBody = await added.json().catch(function () { return null; });
          if (!added.ok) throw new Error((addedBody && (addedBody.description || addedBody.message)) || ('add ' + added.status));
          console.log('[roulette claim] 5. 加购成功', addedBody);

          step = '跳转结账页';
          console.log('[roulette claim] 6. 跳转 /checkout');
          window.location.href = '/checkout';
        } catch (e) {
          console.error('[roulette claim] 失败，停在：' + step, e);
          claimBusy = false;
          claimButton.classList.remove('loading');
          claimButton.removeAttribute('aria-busy');
          const spinner = claimButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      });
    }

    function setResultBlockedCopy(actStatus) {
      const copy = actStatusResultCopy[actStatus];
      if (!copy) return;
      setResultCopy(copy);
    }

    function delay(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    }

    // v3 step 1: fetch (and cache) a draw token for this actId.
    // Returns the token string, or a { blocked } / { error } marker.
    async function fetchToken(actIdValue, signal) {
      const cacheKey = String(actIdValue);
      const cached = tokenCache[cacheKey];
      if (cached && cached.token && cached.expiresAt > Date.now()) {
        return { token: cached.token };
      }
      const sign = buildSign(actIdValue, signSecret);
      const tokenRes = await fetch(tokenUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ actId: actIdValue, sign: sign }),
        signal: signal,
      });
      const tokenJson = await tokenRes.json();
      const tokenData = (tokenJson && tokenJson.data) || {};
      if (tokenJson.code !== 200 || !tokenData.token) {
        const tokenStatus = String(tokenData.act_status || '').trim().toLowerCase();
        if (tokenStatus === 'token_invalid') {
          delete tokenCache[cacheKey];
        }
        return { blocked: tokenStatus || '', error: true };
      }
      const expireMs = (Number(tokenData.expireSeconds) || 86400) * 1000;
      tokenCache[cacheKey] = {
        token: tokenData.token,
        expiresAt: Date.now() + expireMs - 60000,
      };
      return { token: tokenData.token };
    }

    // 配置里有文案的 act_status 保持原提示。接口返回了不认识的状态时，按未中奖展示。
    function outcomeForActStatus(actStatus) {
      if (actStatus && actStatusResultCopy[actStatus]) {
        return { kind: 'blocked', actStatus: actStatus, submitted: false };
      }
      return { kind: 'miss', meta: fallbackMeta, submitted: false };
    }

    async function fetchPrize(email) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 8000);
      try {
        // openapi_v3 expects a JSON body with camelCase fields, plus sign + token.
        // actId is sent as a number when the setting is purely numeric, otherwise as-is.
        const actIdValue = /^\d+$/.test(String(actId).trim()) ? Number(actId) : actId;
        const sign = buildSign(actIdValue, signSecret);

        const tokenResult = await fetchToken(actIdValue, controller.signal);
        if (!tokenResult.token) {
          const tokenStatus = String(tokenResult.blocked || '').trim().toLowerCase();
          if (tokenStatus === 'token_invalid') {
            return { kind: 'blocked', actStatus: 'system_error', submitted: false };
          }
          if (tokenStatus) return outcomeForActStatus(tokenStatus);
          return { kind: 'blocked', actStatus: 'request_failed', submitted: false };
        }

        const res = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            mbId: email || '',
            actId: actIdValue,
            usageScenarios: usageScenarios,
            sign: sign,
            token: tokenResult.token,
          }),
          signal: controller.signal,
        });
        const json = await res.json();
        const data = (json && json.data) || {};
        // Success => top-level code 200 and data.status "ok".
        // Anything else is an error/limit; inspect data.act_status for the reason.
        if (json.code !== 200 || data.status !== 'ok') {
          const actStatus = String(data.act_status || '').trim().toLowerCase();
          if (actStatus === 'token_invalid') {
            delete tokenCache[String(actIdValue)];
            return { kind: 'blocked', actStatus: 'system_error', submitted: false };
          }
          if (actStatus) return outcomeForActStatus(actStatus);
          return { kind: 'blocked', actStatus: 'request_failed', submitted: false };
        }
        // The backend now returns actId + priceId (not a single actPriceId). Match
        // by their string concatenation against each block's configured actId + priceId.
        const respKey = buildPrizeKey(
          data.actId != null ? data.actId : data.act_id,
          data.priceId != null ? data.priceId : data.price_id
        );
        const priceName = data.priceName != null ? data.priceName : data.price_name;
        if (respKey && validPrizeKeys.has(respKey)) {
          const meta = { ...prizeKeyToPrizeMeta[respKey] };
          if (priceName && meta.type === 'product') {
            meta.name = priceName;
          }
          return { kind: 'prize', prizeKey: respKey, meta, submitted: true };
        }
        // "almost" — a real prize that isn't a wheel/carousel block. Recognized by
        // its section-level actId + priceId; lands on the almost sector, copy from the
        // response priceName + isEntity.
        if (almostPrizeKey && respKey === almostPrizeKey) {
          const isEntity = Number(data.isEntity != null ? data.isEntity : data.is_entity);
          return {
            kind: 'almost',
            prizeKey: respKey,
            meta: {
              type: isEntity === 1 ? 'product' : 'coupon',
              name: isEntity === 1 ? priceName : undefined,
              amount: isEntity === 1 ? undefined : priceName,
              headingOverride: '',
              subOverride: '',
            },
            submitted: true,
          };
        }
        return { kind: 'miss', meta: fallbackMeta, submitted: true };
      } catch (e) {
        // 超时（AbortController 触发）→ Request timed out；其它未预期异常 → system_error。
        if (e && e.name === 'AbortError') {
          return { kind: 'blocked', actStatus: 'request_timeout', submitted: false };
        }
        return { kind: 'blocked', actStatus: 'system_error', submitted: false };
      } finally {
        window.clearTimeout(timeout);
      }
    }

    // 重复留邮（act_status = no_finish）时回显历史中奖：
    // 先取 verify token，再查该邮箱在本活动已中的奖，映射回本地的奖品块，
    // 返回与 fetchPrize 同构的 outcome，交给后续 result 分支复用。
    // 任一环节失败返回 null，调用方只弹「已参与」提示。
    async function queryExistingPrize(email) {
      if (!apiKey || actId == null || actId === '') return null;

      try {
        const tokenRes = await fetch(getTokenUrl, {
          method: 'POST',
          headers: {
            'X-Site': xSite,
            'Api-Key': apiKey,
          },
        });
        const tokenJson = await tokenRes.json();
        if (tokenJson.code !== 0 || !tokenJson.data || !tokenJson.data.token) return null;

        const formData = new FormData();
        formData.append('activity_id', String(actId));
        formData.append('email', email || '');

        const queryRes = await fetch(prizeQueryUrl, {
          method: 'POST',
          headers: {
            'X-Site': xSite,
            'Api-Key': apiKey,
            'X-Verify-Token': String(tokenJson.data.token),
            Timestamp: String(tokenJson.data.timestamp),
          },
          body: formData,
        });
        const queryJson = await queryRes.json();
        if (queryJson.code !== 0 || !Array.isArray(queryJson.data) || !queryJson.data.length) {
          return null;
        }

        const row = queryJson.data[0] || {};
        const priceId =
          row.priceId != null
            ? row.priceId
            : row.price_id != null
              ? row.price_id
              : row.prizeId != null
                ? row.prizeId
                : row.prize_id != null
                  ? row.prize_id
                  : null;
        const actPriceId =
          row.actPriceId != null ? row.actPriceId : row.act_price_id != null ? row.act_price_id : null;
        const priceName = row.award_name || row.prize_name || row.priceName || '';
        const code = row.code != null ? row.code : '';
        const isEntity = Number(row.isEntity != null ? row.isEntity : row.is_entity) === 1;

        // 本活动用 actId + priceId 拼 key 匹配奖品块；查询接口可能返回 price_id 或 act_price_id
        const candidates = [];
        if (priceId != null && priceId !== '') candidates.push(String(priceId));
        if (actPriceId != null && actPriceId !== '') candidates.push(String(actPriceId));

        let matchedKey = null;
        for (const candidate of candidates) {
          const key = buildPrizeKey(actId, candidate);
          if (validPrizeKeys.has(key)) {
            matchedKey = key;
            break;
          }
        }

        // 未匹配到奖品块时按 miss 处理（不展示具体奖品，但流程照常收尾）
        if (!matchedKey) {
          return { kind: 'miss', meta: fallbackMeta, fromQuery: true };
        }

        const meta = { ...prizeKeyToPrizeMeta[matchedKey] };
        if (priceName && meta.type === 'product') meta.name = priceName;

        return { kind: 'prize', prizeKey: matchedKey, meta, fromQuery: true };
      } catch (e) {
        return null;
      }
    }

    function landWheelAtPrize({ wheelImgEl, prizeKey, targetDeg }) {
      if (!wheelImgEl) return Promise.resolve();

      return new Promise((resolve) => {
        const startNorm = normalizeDeg(getRotationDeg(wheelImgEl));
        const deg = targetDeg != null ? targetDeg : getSectorDeg(prizeKey);
        const targetNorm = normalizeDeg(deg);
        const deltaToTarget = normalizeDeg(targetNorm - startNorm);
        const extraFullTurns = deltaToTarget === 0 ? 1 : 0;
        const finalDeg = startNorm + extraFullTurns * 360 + deltaToTarget;

        wheelImgEl.classList.remove('is-spinning');
        wheelImgEl.style.transition = '';
        wheelImgEl.style.transform = `rotate(${startNorm}deg)`;
        void wheelImgEl.offsetHeight;

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            wheelImgEl.style.transition = `transform ${decelMs}ms ease-out`;
            wheelImgEl.style.transform = `rotate(${finalDeg}deg)`;

            let resolved = false;
            const cleanup = () => {
              if (resolved) return;
              resolved = true;
              wheelImgEl.removeEventListener('transitionend', onTransitionEnd);
              window.clearTimeout(fallbackTimerId);
              resolve();
            };

            const onTransitionEnd = (e) => {
              if (e.target !== wheelImgEl) return;
              if (e.propertyName !== 'transform') return;
              cleanup();
            };

            wheelImgEl.addEventListener('transitionend', onTransitionEnd);
            const fallbackTimerId = window.setTimeout(cleanup, decelMs + 80);
          });
        });
      });
    }

    // `resolveBlockedLanding`（可选）：当结果是 blocked（例如重复留邮）时，
    // 允许调用方在转盘「落地之前」先决定最终落点（比如查历史中奖并落到对应奖品格）。
    // 返回 null/undefined 时回退到 miss 格子。
    // 这样重复留邮就不会「先停 better luck，再跳到历史中奖格子」两次动画。
    async function spinWheel(email, resolveBlockedLanding) {
      const wheelImgEl = getActiveWheelImg();
      if (!wheelImgEl) return { kind: 'miss', meta: fallbackMeta, submitted: false };

      // CA 合规技能测试：抽奖接口返回后若中奖，先出结果，2s 后再切换做题
      // （见 completion handler）。这里只负责转盘动画本身。
      wheelImgEl.style.transition = '';
      wheelImgEl.style.setProperty('--wheel-rot', '0deg');
      wheelImgEl.classList.add('is-spinning');

      const prizePromise = fetchPrize(email);
      const spinInfiniteMs = spinTotalMs - decelMs;

      await delay(spinInfiniteMs);

      const missOutcome = {
        kind: 'miss',
        meta: fallbackMeta,
        submitted: false,
      };
      const outcome = await Promise.race([
        prizePromise,
        new Promise((resolve) => {
          window.setTimeout(() => resolve(missOutcome), 0);
        }),
      ]);

      // "miss" / "blocked" land on the miss sector; "almost" lands on the almost
      // sector; a wheel prize lands on its block sector.
      if (outcome.kind === 'blocked') {
        // blocked（重复留邮等）：先让调用方决定落点，避免二次动画。
        const resolved = resolveBlockedLanding ? await resolveBlockedLanding(outcome) : null;
        if (resolved && resolved.prizeKey) {
          await landWheelAtPrize({ wheelImgEl, prizeKey: resolved.prizeKey });
        } else if (resolved && resolved.targetDeg != null) {
          await landWheelAtPrize({ wheelImgEl, targetDeg: resolved.targetDeg });
        } else {
          await landWheelAtPrize({ wheelImgEl, targetDeg: getMissSectorDeg() });
        }
        return outcome;
      }
      if (outcome.kind === 'miss') {
        await landWheelAtPrize({ wheelImgEl, targetDeg: getMissSectorDeg() });
        return outcome;
      }
      if (outcome.kind === 'almost') {
        await landWheelAtPrize({ wheelImgEl, targetDeg: getAlmostSectorDeg() });
        return outcome;
      }

      const prizeKey = outcome.prizeKey;
      await landWheelAtPrize({ wheelImgEl, prizeKey });
      return outcome;
    }

    // Shared "the user is submitting" capture: flags the submit + grabs the email
    // so the MutationObserver completion handler runs the spin once Klaviyo
    // confirms the subscribe (input disappears).
    function captureSubmitIntent() {
      buttonClicked = true;
      buttonClickedAtMs = Date.now();
      const { input } = findInner();
      submittedEmail = input && input.value ? input.value.trim() : '';
    }

    // ===== Cloudflare Turnstile（留邮人机验证）=====
    // sitekey 由 section settings 下发（cfg.turnstileSiteKey），为空则完全跳过验证逻辑。
    // 流程：渲染 widget 拿 token → 提交时 POST 后端 verify → 通过才放行 Klaviyo 提交。
    const turnstileSiteKey = String(cfg.turnstileSiteKey || '').trim();
    const turnstileScriptSrc = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    const turnstileVerifyEndpoint = 'https://global.shokz.com/api/v1/email-risk/verify';
    const turnstileFailureMessage = 'Unable to submit at this time. Please try again later.';
    const turnstilePendingMessage = 'Please complete the verification to continue.';
    let turnstileToken = '';
    let turnstileWidgetId = '';
    let turnstileVerifyPromise = null;
    let turnstileVerifyStatus = 'idle'; // idle | pending | passed | failed
    let isTurnstileVerifying = false;
    let isTurnstileLocked = false;
    let allowVerifiedSubmit = false;

    function getTurnstileHost() {
      return root.querySelector('[data-roulette-turnstile]');
    }

    function resetTurnstileToken() {
      turnstileToken = '';
      turnstileVerifyPromise = null;
      turnstileVerifyStatus = 'idle';
      applyTurnstileButtonState();
    }

    function lockTurnstileAfterFailure() {
      isTurnstileLocked = true;
      resetTurnstileToken();
      try {
        if (turnstileWidgetId && window.turnstile) window.turnstile.remove(turnstileWidgetId);
      } catch (e) {}
      getTurnstileHost()?.classList.add('is-hidden');
      applyTurnstileButtonState();
      scheduleReserveLotteryStageHeight();
    }

    async function verifyTurnstileToken(token) {
      const formData = new FormData();
      formData.append('verify_token', token);

      const response = await fetch(turnstileVerifyEndpoint, {
        method: 'POST',
        headers: {
          'X-Site': 'ca',
        },
        body: formData,
      });

      const result = await response.json().catch(function () {
        return {};
      });
      return response.ok && result?.data?.success === true;
    }

    function startTurnstileVerification(token) {
      turnstileVerifyStatus = 'pending';
      turnstileVerifyPromise = verifyTurnstileToken(token)
        .then(function (isVerified) {
          turnstileVerifyStatus = isVerified ? 'passed' : 'failed';
          return isVerified;
        })
        .catch(function (error) {
          turnstileVerifyStatus = 'failed';
          console.warn('[Turnstile] verify request failed', error);
          return false;
        })
        .finally(function () {
          applyTurnstileButtonState();
        });
      applyTurnstileButtonState();
      return turnstileVerifyPromise;
    }

    // Turnstile 未通过（无 token / 后端校验中 / 校验失败 / 已锁定）时挡住 Klaviyo 提交按钮。
    // 不用原生 disabled：原生 disabled 会阻止 click 事件，验证通过后补的 btn.click()
    // 就再也进不来；这里沿用主题的 pointerEvents 方案，并保留点击链路上的兜底拦截。
    function applyTurnstileButtonState() {
      if (!turnstileSiteKey) return;
      const { button } = findInner();
      if (!button) return;
      const shouldBlock = isTurnstileLocked || !turnstileToken || isTurnstileVerifying;
      button.setAttribute('aria-disabled', shouldBlock ? 'true' : 'false');
      if (shouldBlock) {
        // 行内 opacity 会盖过样式表，这里直接写上，未验证时按钮才真的变淡
        button.style.pointerEvents = 'none';
        button.style.opacity = '0.6';
      } else {
        // 交还给主题的勾选态控制（未勾选协议时仍需禁用）
        applyButtonEnablement(button);
      }
    }

    function loadTurnstileScript() {
      if (window.turnstile || document.querySelector('script[src="' + turnstileScriptSrc + '"]')) return;

      const script = document.createElement('script');
      script.src = turnstileScriptSrc;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    function renderTurnstileWidget() {
      const host = getTurnstileHost();
      if (isTurnstileLocked) return;
      if (!host || host.dataset.turnstileRendered === 'true') return;

      if (!window.turnstile) {
        loadTurnstileScript();
        // 脚本被拦截时不要无限轮询，约 30s 后放弃并提示
        const waits = Number(host.dataset.turnstileWaits || 0) + 1;
        host.dataset.turnstileWaits = String(waits);
        if (waits > 100) {
          showTurnstileMessage(turnstileFailureMessage);
          return;
        }
        window.setTimeout(renderTurnstileWidget, 300);
        return;
      }

      turnstileWidgetId = window.turnstile.render(host, {
        sitekey: turnstileSiteKey,
        callback: function (token) {
          turnstileToken = token;
          turnstileVerifyPromise = null;
          turnstileVerifyStatus = 'idle';
          applyTurnstileButtonState();
        },
        'expired-callback': function () {
          resetTurnstileToken();
          console.log('[Turnstile] token expired');
        },
        'error-callback': function () {
          resetTurnstileToken();
          console.warn('[Turnstile] challenge error');
        },
      });

      host.dataset.turnstileRendered = 'true';
      applyTurnstileButtonState();
    }

    function showTurnstileMessage(message) {
      const host = getTurnstileHost();
      const formContent = host ? host.closest('.form-content') : null;
      if (!formContent) return;

      let messageEl = formContent.querySelector('.common-roulette__turnstile-message');
      if (!messageEl) {
        messageEl = document.createElement('div');
        messageEl.className = 'common-roulette__turnstile-message';
        messageEl.setAttribute('role', 'alert');
        formContent.appendChild(messageEl);
      }

      messageEl.textContent = message;
      window.clearTimeout(messageEl._hideTimer);
      messageEl._hideTimer = window.setTimeout(function () {
        messageEl.remove();
      }, 3000);
    }

    // 提交闸门：Turnstile 未通过时拦截这次提交（不进入留邮/抽奖流程），
    // 后端校验通过后置位 allowVerifiedSubmit 并按来源补一次提交：
    // - 按钮点击：补一次 click，走原来的 click 链路
    // - Enter：原生提交已被 preventDefault，需用 requestSubmit 重新提交，
    //   否则卡片永远停在验证通过但不提交的状态
    async function runTurnstileGate(btn, trigger) {
      if (!turnstileToken) {
        showTurnstileMessage(turnstilePendingMessage);
        return;
      }
      if (isTurnstileVerifying) {
        showTurnstileMessage('Please wait a moment and try again');
        return;
      }

      isTurnstileVerifying = true;
      applyTurnstileButtonState();

      try {
        const isVerified =
          turnstileVerifyStatus === 'passed'
            ? true
            : turnstileVerifyStatus === 'failed'
              ? false
              : await (turnstileVerifyPromise || startTurnstileVerification(turnstileToken));
        if (!isVerified) {
          lockTurnstileAfterFailure();
          showTurnstileMessage(turnstileFailureMessage);
          return;
        }

        isTurnstileVerifying = false;
        applyTurnstileButtonState();
        allowVerifiedSubmit = true;
        if (trigger === 'enter') {
          // Enter 的原始提交已被 preventDefault，而且不会触发 click，
          // 所以这里手动记录提交意图再重新提交；否则 Klaviyo 订阅了但
          // MutationObserver 看不到 buttonClicked，转盘不会转。
          captureSubmitIntent();
          const { form } = findInner();
          if (form && typeof form.requestSubmit === 'function') {
            form.requestSubmit();
            return;
          }
        }
        // 点击路径：补一次 click，由 click 监听里的 allowVerifiedSubmit 放行并记录意图
        if (btn) btn.click();
      } catch (error) {
        console.warn('[Turnstile] verify request failed', error);
        lockTurnstileAfterFailure();
        showTurnstileMessage(turnstileFailureMessage);
      } finally {
        isTurnstileVerifying = false;
        applyTurnstileButtonState();
      }
    }

    if (turnstileSiteKey) renderTurnstileWidget();

    if (!klaviyoContainer._rouletteDelegatedClick) {
      klaviyoContainer.addEventListener(
        'click',
        (e) => {
          const target = e.target;
          if (!(target instanceof Element)) return;
          const btn = target.closest('button');
          if (!btn || !klaviyoContainer.contains(btn)) return;
          // Turnstile 闸门：首次点击先做人机验证，通过后置位 allowVerifiedSubmit
          // 并补一次点击；验证不通过则拦截（不进入留邮/抽奖流程）。
          // 不依赖 pointerEvents:none —— 键盘触发的 click 不受它限制，这里统一兜底。
          if (turnstileSiteKey) {
            if (allowVerifiedSubmit) {
              allowVerifiedSubmit = false;
            } else {
              e.preventDefault();
              e.stopImmediatePropagation();
              void runTurnstileGate(btn, 'click');
              return;
            }
          }
          captureSubmitIntent();
        },
        true
      );
      // Pressing Enter in the email input submits the Klaviyo form natively (not
      // via a button click), so the click handler above never fires and the spin
      // is skipped. Capture the same submit intent on Enter so the spin runs too.
      // Turnstile 闸门开启时 Enter 同样先走人机验证，通过后以程序化点击完成提交。
      klaviyoContainer.addEventListener(
        'keydown',
        (e) => {
          if (e.key !== 'Enter' && e.keyCode !== 13) return;
          if (turnstileSiteKey && !allowVerifiedSubmit) {
            e.preventDefault();
            e.stopImmediatePropagation();
            void runTurnstileGate(klaviyoContainer.querySelector('button'), 'enter');
            return;
          }
          // We intentionally do NOT preventDefault — Klaviyo must still subscribe.
          captureSubmitIntent();
        },
        true
      );
      klaviyoContainer._rouletteDelegatedClick = true;
    }

    function checkAndApplyStyles() {
      const { button, input, form } = findInner();
      if (!button || !input || !form) return false;
      if (button.style.display === 'none' || button.style.visibility === 'hidden') return false;

      const mediaQuery = window.matchMedia('(min-width: 901px)');
      const updateStyles = (e) => {
        if (e.matches) {
          input.style.height = '48px';
          button.style.height = '48px';
          button.style.minWidth = '88px';
          button.style.padding = '0 20px';
          input.style.borderRadius = '4px 0 0 4px';
          input.style.border = '1px solid #fff';
          button.style.borderRadius = '0 4px 4px 0';
          button.style.fontSize = '16px';
        } else {
          input.style.height = '10.17811705vw';
          input.style.fontSize = '4.07124682vw';
          button.style.height = '10.17811705vw';
          button.style.padding = '0 2.54452926vw';
          button.style.fontSize = '4.07124682vw';
          input.style.borderRadius = '1.01781170vw 0 0 1.01781170vw';
          input.style.border = '0.25445293vw solid #fff';
          button.style.borderRadius = '0 1.01781170vw 1.01781170vw 0';
        }

        form.style.padding = '0';
        const firstDiv = form.querySelector('div');
        if (firstDiv) firstDiv.style.minHeight = 'unset';
        button.style.background = 'var(--roulette-btn)';
        button.style.color = 'var(--roulette-btn-text)';
        button.style.fontFamily = "'Shokz Sans Display'";
        button.style.fontWeight = '400';
        applyButtonEnablement(button);
        applyTurnstileButtonState();
      };

      if (!buttonHasAppeared) {
        if (mediaQuery.addEventListener) {
          mediaQuery.addEventListener('change', updateStyles);
        } else {
          mediaQuery.addListener(updateStyles);
        }
        button.textContent = (cfg.copy && cfg.copy.formButtonLabel) || 'Enter';
        buttonHasAppeared = true;
      }

      updateStyles(mediaQuery);
      return true;
    }

    function retryApplyStyles() {
      if (retryCount >= maxRetries) return;
      if (!checkAndApplyStyles()) {
        retryCount++;
        window.setTimeout(retryApplyStyles, retryInterval);
      }
    }

    if (agreementEl) {
      agreementEl.addEventListener('change', () => {
        const { button } = findInner();
        applyButtonEnablement(button);
        // 勾选协议会把 pointer-events 设回 auto，Turnstile 未通过时要再盖回去
        applyTurnstileButtonState();
      });
    }

    const observer = new MutationObserver(async function () {
      if (completed) return;
      const { button } = findInner();
      if (button) {
        if (!checkAndApplyStyles()) retryApplyStyles();
      }

      if (buttonHasAppeared && ((!button || isButtonHidden(button)) || isEmailInputGone())) {
        if (!buttonClicked) return;
        const sinceClickMs = Date.now() - (buttonClickedAtMs || 0);
        if (sinceClickMs > 12000) return;

        completed = true;
        observer.disconnect();
        hideAllWheelHints();

        const formContent = root.querySelector('.form-content');
        if (formContent) formContent.style.display = 'none';
        // 技能测试面板与留邮表单同区：提交后先收起，出结果后再按需切换
        hideSkillTest();
        scheduleReserveLotteryStageHeight();

        let spinResult;
        // 重复留邮（no_finish）缓存：resolveBlockedLanding 里查到后存下来，
        // 供后面的 result 分支复用，避免重复请求。
        let existingPrizeForRepeat = null;
        let repeatLandingResolved = false;
        try {
          spinResult = await spinWheel(submittedEmail, async (outcome) => {
            // blocked：重复留邮 → 先查历史中奖，直接落到对应奖品格，
            // 避免「先停 better luck 再跳历史中奖」的二次动画。
            if (outcome && outcome.actStatus === 'no_finish') {
              repeatLandingResolved = true;
              existingPrizeForRepeat = await queryExistingPrize(submittedEmail);
              if (existingPrizeForRepeat && existingPrizeForRepeat.kind === 'prize') {
                return { prizeKey: existingPrizeForRepeat.prizeKey };
              }
            }
            // 其它 blocked（或查不到历史中奖）→ 照旧停在 miss 格子
            return { targetDeg: getMissSectorDeg() };
          });
        } catch (e) {
          spinResult = {
            kind: 'miss',
            meta: fallbackMeta,
            submitted: false,
          };
        }

        // 留邮 subscribe 埋点：module = 活动，status = 留邮结果，button_name = 按钮
        // 参考其他留邮埋点（ga4-code / glo-run-lottery）：留邮成功 → success，失败 → fail
        // 成功 = 抽奖接口 code 200 且 status ok（含未中奖）；失败 = 已参与/限制/网络错误等
        const subscribeStatus = spinResult.submitted ? 'success' : 'fail';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'subscribe',
          event_parameters: {
            module: ga4ModuleName,
            status: subscribeStatus,
            button_name: ga4ButtonName,
          },
        });

        if (spinResult.kind === 'blocked') {
          // Blocked (entry limit / already joined) → wheel popup only.
          const blockedCopy = actStatusResultCopy[spinResult.actStatus] || {};

          if (spinResult.actStatus === 'no_finish') {
            // 重复留邮（同邮箱抽过）：后端不再返奖，改查该邮箱的历史中奖并回显。
            // 查不到（未中奖 / 接口异常）时按原逻辑只弹「已参与」提示。
            // Repeat email entry → replace the inline prompt with the "already joined" copy.
            if (promptEl && blockedCopy.heading) {
              promptEl.textContent = blockedCopy.heading;
            }
            // 转盘已经在 spinWheel 的 resolveBlockedLanding 阶段落到最终格子，
            // 这里直接复用查询结果，不再二次转动。
            const existing = repeatLandingResolved
              ? existingPrizeForRepeat
              : await queryExistingPrize(submittedEmail);
            if (existing && existing.kind === 'prize') {
              hideAllWheelResults();
              const meta = existing.meta || fallbackMeta;
              const copy = buildResultCopy(meta);
              // 重复留邮回显：标题固定为已参与，正文仍回显历史中奖奖品
              copy.heading = "You've already joined!";
              copy.variantIds = meta.variantIds || [];
              copy.prizeCode = meta.prizeCode || '';
              setResultCopy(copy);
            } else {
              // 未中奖的重复留邮：右侧文案区回显未中奖文案（与第一次未中奖一致），
              // 标题固定「已参与」，正文跟上 miss 文案，不再只弹转盘浮层。
              hideAllWheelResults();
              setResultCopy(blockedCopy);
            }
          } else {
            showWheelResult(blockedCopy);
          }
        } else {
          // Win / miss / almost → original right-side copy replacement. "almost"
          // reads the same copy as a true miss, but still lands on its own sector.
          const meta = spinResult.meta || fallbackMeta;
          if (spinResult.kind === 'almost') meta.type = 'miss';
          const copy = buildResultCopy(meta);
          if (spinResult.kind === 'prize') {
            copy.variantIds = meta.variantIds || [];
            copy.prizeCode = meta.prizeCode || '';
          }
          setResultCopy(copy);

          // CA 合规技能测试（3.3.4）：中奖先出结果，2s 后切换为技能测试，
          // 提交（答案非空即可，不校验）后切回开奖结果。未中奖/almost 不出现。
          const isGatedWin =
            skillTestEl &&
            spinResult.kind === 'prize' &&
            meta &&
            meta.type !== 'miss';
          if (isGatedWin) {
            await delay(2000);
            const submitted = await showSkillTest();
            if (submitted !== false) {
              hideSkillTest();
            }
            // 无论技能测试是否正常展示/提交，最终都切回开奖结果态。
            setResultCopy(copy);
          }
        }
        scheduleReserveLotteryStageHeight();
      }
    });

    observer.observe(klaviyoContainer, {
      childList: true,
      subtree: true,
      attributeFilter: ['class'],
    });

    retryApplyStyles();

    const prizeCount = (cfg.displayPrizes || []).length;
    if (prizeCount > 0 && typeof Swiper !== 'undefined') {
      const swiperEl = root.querySelector('.common-roulette-swiper');
      if (swiperEl) {
        const isDesktop = window.matchMedia('(min-width: 901px)').matches;
        const prizeSpaceBetween = isDesktop ? 12 : 10;

        const AUTO_SPEED = 10000;

        const prizeSwiper = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: prizeSpaceBetween,
          loop: true,
          speed: AUTO_SPEED,
          allowTouchMove: true,
          watchOverflow: true,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
        });

        prizeSwiper.on('touchEnd', function () {
          this.params.speed = 300;
        });

        prizeSwiper.on('transitionEnd', function () {
          if (this.params.speed !== AUTO_SPEED) {
            this.params.speed = AUTO_SPEED;
            if (this.autoplay.running) {
              this.autoplay.stop();
              this.autoplay.start();
            }
          }
        });

        const carouselEl = root.querySelector('.prize-carousel');
        if (carouselEl) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  prizeSwiper.autoplay.start();
                } else {
                  prizeSwiper.autoplay.stop();
                }
              });
            },
            { threshold: 0.5 }
          );
          observer.observe(carouselEl);
        }
      }
    }

    // 赠品卡片图片点击 select_content 埋点
    root.querySelectorAll('.common-roulette__prize-card__media, .prize-cards__media').forEach(function (media) {
      media.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'select_content',
          event_parameters: {
            content_type: 'section',
            content_name: 'section_gift',
            button_name: 'Gift_Pack_Image',
          },
        });
      });
    });

    const initialHeadingHTML = h2El ? h2El.innerHTML : '';
    const initialHeadingHidden = h2El ? h2El.hidden : true;
    const initialDesc = descEl ? descEl.textContent : '';
    const displayPrizes = Array.isArray(cfg.displayPrizes) ? cfg.displayPrizes : [];

    function plainPrizeLabel(prize) {
      const raw = prize.metaValue || prize.value || prize.name || '';
      return String(raw)
        .replace(/@br_pc/g, ' ')
        .replace(/\s*\([^)]*\)\s*$/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function measureResultHeight(copy) {
      const stage = root.querySelector('[data-lottery-stage]');
      if (!stage) return 0;
      const probe = document.createElement('div');
      probe.className = 'lottery-stage__result';
      probe.style.position = 'absolute';
      probe.style.left = '0';
      probe.style.top = '0';
      probe.style.visibility = 'hidden';
      probe.style.pointerEvents = 'none';
      probe.style.width = stage.clientWidth + 'px';
      probe.style.overflow = 'hidden';
      const heading = document.createElement('p');
      heading.className = 'common-roulette__subheading';
      heading.setAttribute('data-lottery-heading', '');
      heading.innerHTML = copy.heading || '';
      const desc = document.createElement('p');
      desc.className = 'desc';
      desc.setAttribute('data-lottery-desc', '');
      desc.textContent = copy.main || copy.sub || '';
      probe.appendChild(heading);
      probe.appendChild(desc);
      if (copy.main && copy.sub) {
        const sub = document.createElement('p');
        sub.className = 'result-sub';
        sub.textContent = copy.sub;
        probe.appendChild(sub);
      }
      if (copy.claim) {
        const button = document.createElement('span');
        button.className = 'common-roulette__claim';
        button.textContent = 'Sign in to claim';
        probe.appendChild(button);
      }
      stage.appendChild(probe);
      const height = probe.offsetHeight;
      probe.remove();
      return height;
    }

    function reserveLotteryStageHeight() {
      const stage = root.querySelector('[data-lottery-stage]');
      const idle = root.querySelector('[data-lottery-idle]');
      if (!stage || !idle || !stage.clientWidth) return;
      const copies = [buildResultCopy({ type: 'miss' })];
      displayPrizes.forEach(function (prize) {
        const label = plainPrizeLabel(prize);
        copies.push(buildResultCopy({
          type: prize.type || 'product',
          name: prize.type === 'coupon' ? undefined : label,
          amount: prize.type === 'coupon' ? label : undefined,
          headingOverride: prize.headingOverride || '',
          subOverride: prize.subOverride || '',
        }));
      });
      let maxHeight = idle.offsetHeight;
      copies.forEach(function (copy) {
        maxHeight = Math.max(maxHeight, measureResultHeight(copy));
      });
      if (maxHeight) stage.style.minHeight = maxHeight + 'px';
    }

    let stageHeightFrame = 0;
    function scheduleReserveLotteryStageHeight() {
      if (stageHeightFrame) return;
      stageHeightFrame = window.requestAnimationFrame(function () {
        stageHeightFrame = 0;
        reserveLotteryStageHeight();
      });
    }

    reserveLotteryStageHeight();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(reserveLotteryStageHeight);
    }
    if (window.ResizeObserver) {
      const idle = root.querySelector('[data-lottery-idle]');
      const stage = root.querySelector('[data-lottery-stage]');
      if (idle && stage) {
        const idleObserver = new ResizeObserver(scheduleReserveLotteryStageHeight);
        idleObserver.observe(idle);
      }
    }
    window.addEventListener('resize', reserveLotteryStageHeight);

    function resetWheelMotion() {
      root.querySelectorAll('.wheel-img').forEach(function (wheel) {
        wheel.classList.remove('is-spinning');
        wheel.style.transition = '';
        wheel.style.transform = '';
        wheel.style.setProperty('--wheel-rot', '0deg');
      });
    }

    window.rouletteDebug = {
      reset: function () {
        resetWheelMotion();
        claimOverride = null;
        wonVariantIds = [];
        wonPrizeCode = '';
        claimBusy = false;
        const claimButton = root.querySelector('[data-lottery-claim="ready"]');
        if (claimButton) {
          claimButton.disabled = false;
          claimButton.classList.remove('loading');
          claimButton.removeAttribute('aria-busy');
          const spinner = claimButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
        root.classList.remove('is-result', 'is-result--miss', 'is-win');
        hideClaim();
        if (h2El) {
          h2El.innerHTML = initialHeadingHTML;
          h2El.hidden = initialHeadingHidden;
        }
        if (descEl) descEl.textContent = initialDesc;
        if (promptEl) promptEl.textContent = initialPromptText;
        const formContent = root.querySelector('.form-content');
        if (formContent) formContent.style.display = '';
        hideSkillTest();
        if (skillTestInputEl) skillTestInputEl.value = '';
        skillTestSubmitResolve = null;
        if (resultSubEl) {
          resultSubEl.textContent = '';
          resultSubEl.hidden = true;
        }
        if (resultNoteEl) {
          resultNoteEl.textContent = '';
          resultNoteEl.hidden = true;
        }
      },
      spin: function () {
        const wheel = getActiveWheelImg();
        if (!wheel) return;
        wheel.style.transition = '';
        wheel.style.setProperty('--wheel-rot', '0deg');
        wheel.classList.add('is-spinning');
      },
      win: async function (rank) {
        const index = Number(rank) - 1;
        const prize = displayPrizes[index];
        if (!prize) {
          console.warn('rouletteDebug.win: no prize at rank ' + rank + '. Available: 1-' + displayPrizes.length);
          return;
        }
        const wheel = getActiveWheelImg();
        if (wheel) wheel.classList.remove('is-spinning');
        const deg = isMobile() ? prize.sectorDegMobile : prize.sectorDegDesktop;
        await landWheelAtPrize({ wheelImgEl: wheel, targetDeg: Number(deg) || 0 });
        const label = plainPrizeLabel(prize);
        const copy = buildResultCopy({
          type: prize.type || 'product',
          name: prize.type === 'coupon' ? undefined : label,
          amount: prize.type === 'coupon' ? label : undefined,
          headingOverride: prize.headingOverride || '',
          subOverride: prize.subOverride || '',
        });
        copy.variantIds = prize.variantIds || [];
        copy.prizeCode = prize.prizeCode || '';
        setResultCopy(copy);
      },
      claim: function (state) {
        const allowed = { guest: true, ready: true, claimed: true };
        if (!allowed[state]) {
          console.warn("rouletteDebug.claim('guest' | 'ready' | 'claimed')");
          return;
        }
        claimOverride = state;
        if (root.classList.contains('is-win')) showClaim(state);
      },
      loading: function () {
        root.classList.add('is-result', 'is-win');
        showClaim('ready');
        const button = root.querySelector('[data-lottery-claim="ready"]');
        if (!button) return;
        claimBusy = true;
        button.classList.add('loading');
        button.setAttribute('aria-busy', 'true');
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        console.log('[roulette claim] 预览 CTA loading。rouletteDebug.reset() 恢复');
      },
    };
    console.info("rouletteDebug.reset() 恢复 | rouletteDebug.spin() 一直转 | rouletteDebug.win(1) 第1等奖 | rouletteDebug.claim('guest'|'ready'|'claimed') | rouletteDebug.loading() CTA loading");
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBrandDayLotteries);
} else {
  initBrandDayLotteries();
}
